import "./shadow-over-container.less";

export default function ShadowOverContainer() {
  return <div className="shadow-over-container" />
}